import { render, staticRenderFns } from "./editBoard.vue?vue&type=template&id=02dc4538&scoped=true"
import script from "./editBoard.vue?vue&type=script&lang=js"
export * from "./editBoard.vue?vue&type=script&lang=js"
import style0 from "./editBoard.vue?vue&type=style&index=0&id=02dc4538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dc4538",
  null
  
)

export default component.exports